export default __webpack_public_path__ + "static/media/submitBackgroundLG.1399c2f8.svg";